import { COLORS } from '@alto/design-library-tokens';
import { Body, Icon, Pressable, Row } from '@alto/design-system';
import { useNavigation } from '@alto/navigation';
import React from 'react';

type Props = {
  readonly href?: string;
  readonly to?: string;
  readonly text: string;
};

export const BackLink = ({ href, text, to = '/' }: Props) => {
  const { navigate } = useNavigation();
  return (
    <Pressable
      aria-label={text}
      onPress={() => {
        if (href) {
          window.location.href = href;
        } else {
          navigate(to);
        }
      }}
    >
      <Row centerVertically>
        <Icon
          name="chevronleft-small"
          type="secondary"
          accessibilityLabel="Press to go back"
        />
        <Body color={COLORS.TEXT_COLORS.SECONDARY}>{text}</Body>
      </Row>
    </Pressable>
  );
};
